import { useEffect } from 'react';
import { SuggestionStatus } from '@teetsh/app/src/containers/CahierJournal/EventModal/cjTypes';
import { trackEvent } from '@teetsh/app/src/queries/user/track';
import { Suggestion } from './types';
import { atom } from 'jotai/index';
import { useAtom } from 'jotai';

const suggestionStatusAtom = atom<SuggestionStatus>({
  hasBeenShown: false,
  hasBeenClicked: false,
});

export function useBoSuggestionTracking() {
  const [suggestionStatus, setSuggestionStatus] =
    useAtom<SuggestionStatus>(suggestionStatusAtom);
  useEffect(
    () => () => {
      setSuggestionStatus({
        hasBeenShown: false,
        hasBeenClicked: false,
      });
    },
    [],
  );

  const onSuggestions = (v: Suggestion[]) => {
    setSuggestionStatus({
      hasBeenShown: true,
      suggestions: v,
    });
  };
  const onSuggestionsClick = (v: {
    matiere?: {
      input: string;
      valueClicked: string;
    };
    domaine?: {
      input: string;
      valueClicked: string;
    };
    competence?: {
      input: string;
      valueClicked: string;
    };
    objectif?: {
      input: string;
      valueClicked: string;
    };
  }) => {
    const suggest: SuggestionStatus = {
      hasBeenShown: true,
      hasBeenClicked: true,
    };
    if (v.matiere) {
      suggest.matiereClicked = v.matiere;
    }
    if (v.domaine) {
      suggest.domaineClicked = v.domaine;
    }
    if (v.competence) {
      suggest.competenceClicked = v.competence;
    }
    if (v.objectif) {
      suggest.objectifClicked = v.objectif;
    }

    setSuggestionStatus(suggest);
  };

  return {
    suggestionStatus,
    onSuggestionsClick,
    onSuggestions,
  };
}

export function useTrackSuggestions() {
  const [suggestionStatus] = useAtom<SuggestionStatus>(suggestionStatusAtom);

  return ({
    page,
    title,
    matieres,
    domaines,
    competences,
    goals,
  }: {
    page: string;
    title: string;
    matieres: string[];
    domaines: string[];
    competences: string[];
    goals: string[];
  }) => {
    const isEmptyBo =
      (matieres || []).length === 0 &&
      (domaines || []).length === 0 &&
      (competences || []).length === 0 &&
      (goals || []).length === 0;
    if (
      suggestionStatus.hasBeenShown &&
      !suggestionStatus.hasBeenClicked &&
      !isEmptyBo
    ) {
      trackEvent(`${page}:suggestionsShownButNotClicked`, {
        finalTitle: title,
        suggestions: JSON.stringify(suggestionStatus.suggestions),
        boFields: JSON.stringify({
          matieres: matieres || [],
          domaines: domaines || [],
          competences: competences || [],
          objectifs: goals || [],
        }),
      });
    }
    if (suggestionStatus.hasBeenClicked) {
      trackEvent(`${page}:suggestionsShownAndClicked`, {
        finalTitle: title,
        suggestions: JSON.stringify(suggestionStatus.suggestions),
        matiereClickedValue: suggestionStatus.matiereClicked?.valueClicked,
        matiereClickedInput: suggestionStatus.matiereClicked?.input,
        domaineClickedValue: suggestionStatus.domaineClicked?.valueClicked,
        domaineClickedTitle: suggestionStatus.domaineClicked?.input,
        competenceClickedValue:
          suggestionStatus.competenceClicked?.valueClicked,
        competenceClickedTitle: suggestionStatus.competenceClicked?.input,
        objectifClickedValue: suggestionStatus.objectifClicked?.valueClicked,
        objectifClickedTitle: suggestionStatus.objectifClicked?.input,
      });
    }
  };
}
